export default "__VITE_ASSET__BvjT50Ph__"